import { useContext } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./PigReceiver.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { pigState, updatePigSignals, removePig} from "./PigEngine";

import { trackPageVisit } from "../competency/PageTracker";



 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }



function PigReceiver() {

        useEffect(() => {
  
    trackPageVisit("PigReceiver");
  
  }, []);

  const {  valves, toggleValve } = useContext(WellContext);

  const [, forceRender] = useState(0);

useEffect(() => {

  const renderLoop = setInterval(() => {

    forceRender(v => v + 1);

  }, 30);

  return () => clearInterval(renderLoop);

}, []);



     const [valveData, setValveData] = useState(() => {
    const saved = localStorage.getItem("PigReceiver_valveData");
    return saved
      ? JSON.parse(saved)
      : {
            FCV_11001: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_11002: { mode: "Manual", opening: 0, sp: "", pv: "" },

            };
        });



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("PigReceiver_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
    setValveData(prev => ({
      ...prev,
      [tag]: {
        ...prev[tag],
        [field]: field === "opening" ? Number(value) || 0 : value
      }
    }));
  };

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };





 const isXV11001Open = valves?.XV_11001 === false;
 const isXV11002Open = valves?.XV_11002 === false;
 const isXV11003Open = valves?.XV_11003 === false;



   /* ================= LOCAL DCS SIMULATION ================= */

  // Receiver flow (decays after pig arrival)
  const FIC_11003 =
    isXV11001Open && isXV11002Open
      ? 250
      : isXV11001Open
        ? 450
        : 0;

  // Line pressure after transfer
  const PT_11002 =
    pigState.paused ? 3.1 : 1.2;

  // Pig barrel pressure (build-up when blocked)
  const PT_11001 =
    pigState.paused
      ? 2.8
      : 1.2;

  // Temperature rises slightly during flow restriction
  const TT_11001 = pigState.paused ? 
    41  : 38 + (FIC_11003 / 30);

  // Valve position indicators (ZT)
  const ZT_11001 = isXV11001Open ? 1 : 0;


  const FIC_11001 = 20 * (valveData.FCV_11001.opening)/100;
  const FIC_11006 = isXV11003Open ? FIC_11001 : 0;
  const FIC_11004 = 150 * (valveData.FCV_11002.opening)/100;




useEffect(() => {

  updatePigSignals({

    isXV11001Open,
    isXV11002Open
  });

}, [

  isXV11001Open,
  isXV11002Open
]);





  return (
    <div className="PigReceiver-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "-18px",
        left: "252px",
        color: "white",
        background: "rgba(39, 18, 233, 0.5)",
        padding: "2.2px 301px"
      }}>
        PIG RECEIVER
      </h2>


    {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-10905 */}
      <Valve
        className="XV-11001"
        tag="XV_11001"
        x={685}
        y={250}
        isClosed={valves.XV_11001}
        toggle={toggleValve}
      />

            {/* XV-11002 */}
      <Valve
        className="XV-11002"
        tag="XV_11002"
        x={1020}
        y={300}
        isClosed={valves.XV_11002}
        toggle={toggleValve}
        r={90}
      />

      
      {/* XV-11003 */}
      <Valve
        className="XV-11003"
        tag="XV_11003"
        x={928}
        y={473}
        isClosed={valves.XV_11003}
        toggle={toggleValve}
      />




      {/* ================= CONTROL VALVES SVG ================= */}

        {/* FCV-11001 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-11001"
          style={{ position: "absolute", left: 163, top: 58 }}  onClick={() => openPanel("FCV_11001")}>
          
          <defs>
            <linearGradient id="metal_11001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_11001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_11001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


         {/* FCV-11002 */}
        <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-11002"
          style={{ position: "absolute", left: 1040, top: 85 }}  onClick={() => openPanel("FCV_11002")}>
          
          <defs>
            <linearGradient id="metal_11002">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_11002)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_11002)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


     
      {/* ================= FACEPLATES ================= */}
      {openPanels.map((tag, index) => (
        <ControlValveControlPanel
          key={tag}
          tag={tag}
          data={valveData[tag]}
          update={updateValveData}   // ✅ FIXED
          close={() => closePanel(tag)}
          defaultPosition={{
            x: 300 + index * 40,
            y: 150 + index * 40
          }}
        />
      ))}





      <div
          onClick={removePig}
          style={{
            position:"absolute",
            left: 20,
            top: 230,
            padding:"10px 10px",
            background: "#222",
            color: "white",
            cursor: "pointer",
            border:"2px solid cyan",
            borderRadius: "6px",
            zIndex: 5000,
            userSelect: "none",
            transition: "0.3s"
          }}
        >
          Remove Pig
        </div>


        {
          pigState.visible &&
          pigState.route === "receiver" && (

            <svg
              style={{
                position:"absolute",
                left: pigState.x,
                top: pigState.y,
                overflow:"visible",
              }}
              width={
                pigState.shape === "rect"
                  ? 60
                  : 35
              }

              height={
                pigState.shape === "rect"
                  ? 30
                  : 35
              }
            >

              {
                pigState.shape === "rect" ? (

                  <rect
                    x="0"
                    y="0"
                    rx="10"
                    ry="10"
                    width="60"
                    height="30"
                    fill="red"
                    stroke="lime"
                    strokeWidth="2"
                  />

                ) : (

                  <circle
                    cx="15"
                    cy="15"
                    r="10"
                    fill="yellow"
                    stroke="black"
                    strokeWidth="2"
                  />

                )
              }

            </svg>
          )
        }

        <div
          style={{
            position: "absolute",
            left: pigState.x,
            top: pigState.y - 20,
            color: "yellow",
            zIndex: 9999
          }}
        >
          X:{Math.round(pigState.x)} Y:{Math.round(pigState.y)}
        </div>


      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={valveData.FCV_11001.opening}
        x={180}
        y={101}
      />

       <ValveOutput
        value={valveData.FCV_11002.opening}
        x={1057}
        y={130}
      />








      {/* Flow in receiver line */}
      <Transmitter
        tag="FIC-11003"
        value={[FIC_11003]}
        x={1085}
        y={220}
        unit="SCF/S"
        max={500}
        HH={450}
        H={350}
        L={100}
        LL={20}
        c="cyan"
        description="FLOW INTO PIG RECEIVER HEADER"
      />

      {/* Receiver barrel pressure */}
      <Transmitter
        tag="PT-11001"
        value={[PT_11001]}
        x={195}
        y={220}
        unit="MPa"
        max={3}
        HH={2.5}
        H={2}
        L={0.5}
        LL={0.1}
        c="lime"
        description="PIG RECEIVER BARREL PRESSURE"
      />

      {/* Line pressure after branch */}
      <Transmitter
        tag="PT-11002"
        value={[PT_11002]}
        x={895}
        y={220}
        unit="MPa"
        max={3}
        HH={2.5}
        H={2}
        L={0.5}
        LL={0.1}
        c="lime"
        description="DOWNSTREAM LINE PRESSURE AT RECEIVER ENTRY"
      />

      {/* Temperature */}
      <Transmitter
        tag="TT-11001"
        value={[TT_11001]}
        x={820}
        y={220}
        unit="°C"
        max={120}
        HH={90}
        H={70}
        L={20}
        LL={10}
        c="orange"
        description="TEMPERATURE AT RECEIVER SECTION"
      />


      <Transmitter
        tag="FIC-11001"
        value={[FIC_11001]}
        x={284}
        y={49}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF NITROGEN TO PIG RECEIVER FOR PURGING"
      />

      <Transmitter
        tag="FIC-11006"
        value={[FIC_11006]}
        x={539}
        y={443}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF NITROGEN AND FLUIDS/IMPURITIES TO CLOSE DRAIN AFTER PURGING OF PIG RECEIVER BARREL"
      />

      <Transmitter
        tag="FIC-11004"
        value={[FIC_11004]}
        x={922}
        y={113}
        unit="LPM"
        max={180}
        HH={130}
        H={125}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF PIGGED FLUID FOR EXPORT VIA LOADING BOAT"
      />

     

      

    </div>
  );
}

export default PigReceiver;


